import "@/App.css";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@/theme/ThemeProvider";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import { router } from "@/router";

/**
 * App root: global providers (theme + error boundary) wrapping the router.
 * Query client + StrictMode live in index.js.
 */
export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </ErrorBoundary>
  );
}
